import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { DashboardService } from '@pages/dashboard/dashboard.service';
import { filter, firstValueFrom } from 'rxjs';
import { NafathStatusEnums } from '@common/enums/nafath.enum';
import { FirebaseRemoteConfigService } from '@common/services/firebase-remote-config.service';

export const nafathGuard: CanActivateFn = async () => {
  const dashboardService = inject(DashboardService);
  const router = inject(Router);
  // wathiq_rollback - Inject FirebaseRemoteConfigService for centralized wathiq flow status
  const firebaseRemoteConfigService = inject(FirebaseRemoteConfigService);

  // Fetch investor profile
  await firstValueFrom(dashboardService.fetchInvestorProfileData());

  await firstValueFrom(
    dashboardService.investorProfile.pipe(
      filter(profile => profile !== undefined)
    )
  );

  const investorProfile = dashboardService.investorProfile.getValue();

  // wathiq_rollback - If investor type is 2 (corporate) AND wathiq flow is enabled, redirect to wathiq
  if (
    firebaseRemoteConfigService.turn_on_watheeq_flow() &&
    investorProfile?.investor?.type === 2
  ) {
    router.navigate(['/auth/wathiq']);
    return false;
  }

  // If investor type is 1 (individual), allow access to nafath
  if (investorProfile?.investor?.type === 1) {
    const nafathStatus = investorProfile?.investor?.nafathRequestStatus;
    const nafathExpireSoon = investorProfile?.investor?.nafathRequestExpireSoon;

    // If nafath is already completed AND not expiring soon, redirect to dashboard
    if (nafathStatus === NafathStatusEnums.COMPLETED && !nafathExpireSoon) {
      router.navigate(['/dashboard']);
      return false;
    }

    // Allow access to nafath screen (for incomplete, deprecated, or expiring soon)
    return true;
  }

  // Default: redirect to dashboard
  router.navigate(['/dashboard']);
  return false;
};
